<template>
    <div :class="`edc-alert ${type} ${isOpen ? 'open' : 'close'}`">
        <div class="edc-alert__content">
            <div class="edc-alert__icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" >
                    <path d="M13 7.5C13 7.76522 12.8946 8.01957 12.7071 8.20711C12.5196 8.39464 12.2652 8.5 12 8.5C11.7348 8.5 11.4804 8.39464 11.2929 8.20711C11.1054 8.01957 11 7.76522 11 7.5C11 7.23478 11.1054 6.98043 11.2929 6.79289C11.4804 6.60536 11.7348 6.5 12 6.5C12.2652 6.5 12.5196 6.60536 12.7071 6.79289C12.8946 6.98043 13 7.23478 13 7.5ZM10 11.25C10 11.0511 10.079 10.8603 10.2197 10.7197C10.3603 10.579 10.5511 10.5 10.75 10.5H12.25C12.4489 10.5 12.6397 10.579 12.7803 10.7197C12.921 10.8603 13 11.0511 13 11.25V15.5H13.75C13.9489 15.5 14.1397 15.579 14.2803 15.7197C14.421 15.8603 14.5 16.0511 14.5 16.25C14.5 16.4489 14.421 16.6397 14.2803 16.7803C14.1397 16.921 13.9489 17 13.75 17H10.75C10.5511 17 10.3603 16.921 10.2197 16.7803C10.079 16.6397 10 16.4489 10 16.25C10 16.0511 10.079 15.8603 10.2197 15.7197C10.3603 15.579 10.5511 15.5 10.75 15.5H11.5V12H10.75C10.5511 12 10.3603 11.921 10.2197 11.7803C10.079 11.6397 10 11.4489 10 11.25Z" />
                    <path d="M12 1C18.075 1 23 5.925 23 12C23 18.075 18.075 23 12 23C5.925 23 1 18.075 1 12C1 5.925 5.925 1 12 1ZM2.5 12C2.5 14.5196 3.50089 16.9359 5.28249 18.7175C7.06408 20.4991 9.48044 21.5 12 21.5C14.5196 21.5 16.9359 20.4991 18.7175 18.7175C20.4991 16.9359 21.5 14.5196 21.5 12C21.5 9.48044 20.4991 7.06408 18.7175 5.28249C16.9359 3.50089 14.5196 2.5 12 2.5C9.48044 2.5 7.06408 3.50089 5.28249 5.28249C3.50089 7.06408 2.5 9.48044 2.5 12Z" />
                </svg>
            </div>
            <p class="edc-alert__message">{{ message }}</p>
        </div>
    </div>
</template>

<script>
export default {
    name: "edc-alert",
    props: {
        type: {
            type: String,
            required: true,
            validator(value) {
                return ['info', 'success', 'warning', 'danger'].includes(value)
            }
        },
        message: {
            type: String,
            required: true
        },
        isOpen: {
            type: Boolean,
            required: true
        }
    }
}
</script>

<style>
.edc-alert {
    max-width: 250px;
    position: fixed;
    right: 20px;
    top: 80px;
    background-color: white;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
    border-radius: 8px;
    overflow: hidden;
    z-index: 99;
    transition: all .25s;
}

.edc-alert.open {
    transform: translateX(0);
}

.edc-alert.close {
    transform: translateX(150%);
}

.edc-alert.info {
    background-color: #A153AA;
    color: white;
    fill: white;
}

.edc-alert.success {
    background-color: #83A30F;
    color: white;
    fill: white;
}

.edc-alert.warning {
    background-color: #FFC107;
    color: var(--color-dark);
    fill: var(--color-dark);
}

.edc-alert.danger {
    background-color: #EB5E5E;
    color: white;
    fill: white;
}

.edc-alert__content {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    padding: 16px;
}

.edc-alert__icon {
    display: flex;
    justify-content: center;
    align-items: center;
}

.edc-alert__icon svg {
    fill: inherit;
}

.edc-alert__message {
    position: relative;
    top: 1px;
    color: inherit;
}
</style>
